import { useState } from 'react';
import { useAppStore } from '../../store/appStore';
import {
  createPlayerLevelScreenModel,
  type PlayerLevelScreenProps,
} from './PlayerLevelScreenModelScreen';
import { PlayerLevelScreenController } from './PlayerLevelScreenController';
import { PlayerLevelScreenView } from './PlayerLevelScreenView';
import { useInfoPopupState } from '../shared/infoPopup/infoPopupState';

export type { PlayerLevelScreenProps } from './PlayerLevelScreenModelScreen';

type PlayerLevelScreenConnectedProps = Omit<
  PlayerLevelScreenProps,
  'successfulDeliveries' | 'averageRating'
>;

export function PlayerLevelScreen(props: PlayerLevelScreenConnectedProps) {
  const successfulDeliveries = useAppStore((s) => s.playerEconomy.ratedDeliveriesCount);
  const averageRating = useAppStore((s) => s.playerEconomy.totalRating);
  const infoPopup = useInfoPopupState();
  const [page, setPage] = useState(0);
  const model = createPlayerLevelScreenModel(
    { ...props, successfulDeliveries, averageRating },
    {
      ...infoPopup,
      page,
      setPage,
    },
  );
  const controller = new PlayerLevelScreenController(model);

  return <PlayerLevelScreenView model={model} controller={controller} />;
}
